import { useState, useEffect, useCallback, useRef } from 'react';

export function useStudyTimer(
  initialSeconds: number,
  onComplete: () => void
) {
  const [remaining, setRemaining] = useState(initialSeconds);
  const [isPaused, setIsPaused]   = useState(false);

  // addTime が呼ばれるたびに increment → effect を強制再実行
  const [restartKey, setRestartKey] = useState(0);

  const onCompleteRef = useRef(onComplete);
  const completedRef  = useRef(false);
  const remainingRef  = useRef(remaining);

  onCompleteRef.current = onComplete;

  useEffect(() => { remainingRef.current = remaining; }, [remaining]);

  useEffect(() => {
    if (isPaused || remainingRef.current <= 0) return;

    const id = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          if (!completedRef.current) {
            completedRef.current = true;
            setTimeout(() => onCompleteRef.current(), 0);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(id);
  // restartKey を deps に加えることで addTime 後に必ず再起動する
  }, [isPaused, restartKey]);

  const pause  = useCallback(() => setIsPaused(true), []);
  const resume = useCallback(() => setIsPaused(false), []);

  const addTime = useCallback((seconds: number) => {
    completedRef.current = false;
    setRemaining((prev) => prev + seconds);
    setIsPaused(false);
    setRestartKey((k) => k + 1); // インターバルを強制再起動
  }, []);

  const formatTime = useCallback((secs: number) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }, []);

  return { remaining, isPaused, pause, resume, addTime, formatTime };
}
